// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    CanDeleteCategoryHasTask: 'Je nemožné zmazať kategóriu, ktorá je použitá v činnostiach.',
    CanDeleteVacationTypeDefault: 'Je nemožné odstrániť štandardný typ dovolenky.',
    CanDeleteVacationTypeHasVacation: 'Je nemožné odstrániť typ dovolenky, ktorá je už pripojená.',
    Completed_Projects: 'Kompletné projekty',
    Completed_Tasks: 'Kompletné činnosti',
    next_month: 'Ďalší mesiac',
    next_week: 'Ďalší týždeň',
    previous_month: 'Predchádzajúci mesiac',
    previous_week: 'Predchádzajúci týždeň',
    previous_year: 'Predcházajúci rok',
    select: 'Vybrať',
    this_month: 'Tento mesiac',
    this_week: 'Tento týždeň',
    this_year: 'Tento rok',
    today: 'Dnes',
    yesterday: 'Včera',
};
